import React, { useState, createContext, useEffect } from "react";
import "./App.css";
import DashboardIndex from "./components/Dashboard/DashboardIndex";
import Login from "./components/login-page/Login";
import "bootstrap/dist/css/bootstrap.min.css";
import "bootstrap/dist/js/bootstrap.bundle.min";
import { BrowserRouter as Router, Routes, Route, Navigate } from "react-router-dom";
import subDays from "date-fns/subDays";
import PrivacyPolicy from "./components/Dashboard/pages/PrivacyPolicy.jsx";
import TermsConditions from "./components/Dashboard/pages/TermsConditions.jsx";
import { initializeTokenRefresh } from "./refershTokenManage/axiosConfig.js";
import ForgotPassword from "./components/login-page/forgot-password/ForgotPassword.jsx";
import ResetPassword from "./components/login-page/reset-password/ResetPassword.jsx";
const LoginContext = createContext();

function App() {
  const user_id = localStorage.getItem("user_id"),
    isLoggedIn = user_id > 0 ? true : false,
    [user, setUser] = useState({
      isLoggedIn: isLoggedIn,
      permissions: localStorage.getItem("permissions"),
    }),
    [createUser, setCreateUser] = useState(false),
    [createAccountManager, setCreateAccountManager] = useState(false),
    [selectedDays, setSelectedDays] = useState([
      subDays(new Date(), 30 - 1),
      new Date(),
    ]),
    [theme, setTheme] = useState("light"),
    [fullScreen, setFullScreen] = useState(false),
    [activeIndex, setActiveIndex] = useState(null),
    [isSidebarOpen, setIsSidebarOpen] = useState(true);

  useEffect(() => {
    document.title = process.env.REACT_APP_NAME || "Infynalytics";
    const savedTheme = localStorage.getItem("theme") || "light";
    setTheme(savedTheme);
    document.addEventListener("fullscreenchange", (event) => {
      if (!document.fullscreenElement) {
        setFullScreen(false);
      }
    });
    if (localStorage.getItem("token")) {
      initializeTokenRefresh();
    }
  }, []);

  useEffect(() => {
    document.documentElement.setAttribute("data-theme", theme);
    localStorage.setItem("theme", theme);
  }, [theme]);

  const toggleTheme = () => {
    setTheme(theme === "light" ? "dark" : "light");
  };

  return (
    <LoginContext.Provider
      value={{
        user,
        setUser,
        createUser,
        setCreateUser,
        createAccountManager,
        setCreateAccountManager,
        selectedDays,
        setSelectedDays,
        theme,
        setTheme,
        toggleTheme,
        fullScreen,
        setFullScreen,
        activeIndex,
        setActiveIndex,
        isSidebarOpen,
        setIsSidebarOpen,
      }}
    >
      <Router>
        <Routes>
          {/* Public Routes */}
          <Route path="/reset-password" element={<ResetPassword />} />
          <Route path="/forgot-password" element={<ForgotPassword />} />
          <Route path="/privacy-policy" element={<PrivacyPolicy />} />
          <Route path="/terms-and-conditions" element={<TermsConditions />} />
          <Route path="/" element={<Login setUser={setUser} />} />

          {/* Protected Routes */}
          <Route
            path="/*"
            element={
              user.isLoggedIn ? (
                <DashboardIndex />
              ) : (
                <Navigate to="/" replace />
              )
            }
          />
        </Routes>
      </Router>
    </LoginContext.Provider>
  );
}

export { App, LoginContext };